<div class="header">
    <div class="buttonBack" (click)="onClickBack($event)">
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
        <i class="fa fa-times" aria-hidden="true"></i>
    </div>
    <shared-active-slots-item-header [route]="route" class="booking"
        [ngClass]="{'reduced':selectedOptionId == 'SLOTS' && _phasesSlots}"></shared-active-slots-item-header>
    <div class="zonaOptions">
        <div class="formarara">
            <options [optionstrip]="options" (clickOption)="onClickOption($event)"></options>
        </div>
    </div>
</div>
<div #scrollContainer *ngIf="route" class="desplegable">
    <div class="dummy"></div>
    <ng-container *ngIf="selectedOptionId == 'SLOTS' && _phasesSlots">
        <div class="phase-block" *ngFor="let phase of _phasesSlots; let i = index">
            <shared-active-slots-item-phase class="booking" [phase]="phase" [intervals]="true"
                (refreshRoute)="refreshRoute($event)"></shared-active-slots-item-phase>
        </div>
    </ng-container>

    <!-- CHAT -->
    <shared-chat class="chats-body-zonachat chat-without-header limitat" *ngIf="selectedOptionId == 'CHAT'"
        [forcedOwnerParticipant]="chatOwner" [notes]="true">
    </shared-chat>

    <!-- LOG -->
    <shared-route-item-log-maintenance *ngIf="selectedOptionId == 'LOG'" [routeId]="route.routeId">
    </shared-route-item-log-maintenance>

    <!-- CONDUCTOR -->
    <ng-container *ngIf="selectedOptionId == 'DRIVER'">
        <shared-driverplate class="limitat padding" *ngIf="showAssignDriverAndPlates" [routeId]="route.routeId"
            [showCarrierCard]="false" [readonly]="!(canAssignDriverAndPlates || hascarrier)">
        </shared-driverplate>

        <shared-route-partner-selector class="limitat padding" [routeId]="route.routeId" [readonly]="readonly"
            (valueChanged)="reloadRoute()"></shared-route-partner-selector>
    </ng-container>

    <ng-container *ngIf="selectedOptionId == 'CONTAINER'">
        <shared-containernumber class="limitat padding" [routeId]="route.routeId"></shared-containernumber>
    </ng-container>

    <!-- DOCUMENTACIÓ -->
    <shared-documentaryreview-route-item *ngIf="selectedOptionId == 'MANAGEMENTMODEL'" class="resta padding"
        [routeId]="route.routeId" (dataUpdated)="onRouteDocumentaryReviewUpdated($event)">
    </shared-documentaryreview-route-item>
</div>